import React from 'react'
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material'
import clsx from 'clsx'
import Grid from '@mui/material/Grid'
import useStyles from './styles/DefaultDialogStyles'
import { DefaultDialogProps } from './types/DefaultDialog'
import { CloseIcon } from '../../../assets/icons'

const initialClassnames = {
    dialogContent: null,
    paper: null,
}

const DefaultDialog = ({
    title,
    subtitle,
    subtitleTopOfTitle,
    buttons,
    children,
    open = false,
    handleClose = () => undefined,
    isFixedButtons = false,
    largePadding = false,
    isTiny = false,
    zIndex = 999999,
    classNames = initialClassnames,
    customDialogFixedButtons = null,
    minWidth = '50vh',
    minHeight = '50vh',
    height,
    width,
    withQuitButton = true,
    disableBackdropClick = false,
    quitButtonText = 'Annuler',
    quitButtonCy,
    secondaryButton,
    secondaryAction,
    fullscreen,
    innerQuitButton,
    scrollable,
    sx,
}: DefaultDialogProps) => {
    const classes = useStyles({ zIndex, largePadding, minHeight, minWidth, height, width, scrollable })

    return (
        <Dialog
            classes={{
                paper: clsx(
                    classes.DefaultDialogPaper,
                    isTiny && classes.DefaultDialogPaperTiny,
                    fullscreen && classes.DefaultDialogPaperFullscreen,
                    classNames.paper,
                    innerQuitButton && classes.DefaultDialogPaperInnerQuitButton,
                ),
            }}
            sx={sx}
            className={classes.DefaultDialog}
            open={open}
            onClose={handleClose}
            disableEscapeKeyDown={disableBackdropClick}
            // @ts-expect-error TS(2322) FIXME: Type '{ children: any[]; classes: { paper: string;... Remove this comment to see the full error message
            fullscreen={fullscreen ? fullscreen.toString() : undefined}
        >
            {withQuitButton && (
                <Box className={innerQuitButton ? classes.DefaultDialogCloserContainer : ''}>
                    <Button
                        className={clsx(
                            classes.DefaultDialogCloser,
                            innerQuitButton && classes.DefaultDialogCloserinnerQuitButton,
                        )}
                        onClick={handleClose}
                        data-cy={quitButtonCy}
                    >
                        <Typography
                            className={clsx(
                                classes.DefaultDialogCloserText,
                                innerQuitButton && classes.DefaultDialogCloserTextinnerQuitButton,
                            )}
                        >
                            {quitButtonText}
                        </Typography>
                        <CloseIcon
                            className={clsx(
                                classes.DefaultDialogCloserIcon,
                                innerQuitButton && classes.DefaultDialogCloserIconinnerQuitButton,
                            )}
                        />
                    </Button>
                </Box>
            )}
            <div
                className={clsx(
                    classes.DefaultDialogContent,
                    isFixedButtons && classes.DefaultDialogContentWithFixedButtons,
                    classNames.dialogContent,
                )}
                data-cy="defaultDialogContent"
            >
                <DialogContent className={classes.DefaultDialogContentDialog}>
                    {subtitle && subtitleTopOfTitle && (
                        <DialogTitle className={classes.DefaultDialogSubtitle}>{subtitle}</DialogTitle>
                    )}
                    <Grid container>
                        {title && <DialogTitle className={classes.DefaultDialogTitle}>{title}</DialogTitle>}
                        {secondaryButton && (
                            <Button
                                style={{
                                    marginLeft: 'auto',
                                }}
                                onClick={secondaryAction}
                            >
                                {secondaryButton}
                            </Button>
                        )}
                    </Grid>
                    {subtitle && !subtitleTopOfTitle && (
                        <DialogTitle className={classes.DefaultDialogSubtitle}>{subtitle}</DialogTitle>
                    )}
                    {children}
                    {!isFixedButtons && buttons && (
                        <div className={classes.DefaultDialogButtons}>{!isFixedButtons && buttons}</div>
                    )}
                </DialogContent>
                {isFixedButtons && buttons && (
                    <DialogActions className={clsx(classes.DefaultDialogFixedButtons, customDialogFixedButtons)}>
                        {buttons}
                    </DialogActions>
                )}
            </div>
        </Dialog>
    )
}

export default DefaultDialog
